// extracted by mini-css-extract-plugin
export default {"reviewHistoryModal":"ReviewModal_reviewHistoryModal__1eT4O","dateCell":"ReviewModal_dateCell__J7aQS"};